<template>
  <h2 class="prose-h2">
    <slot />
  </h2>
</template>
